<template xmlns:v-resize="http://www.w3.org/1999/xhtml">
    <div
        id="mapview"
        v-resize:debounce="resizeMap"
        class="content-container"
        @contextmenu="openMenu"
    >
        <div
            id="map-canvas"
            ref="map-canvas"
            class="map-style"
            @touchstart="touchmove"
            @mousemove="mousemove"
        />
        <l-map
            v-show="showMap"
            ref="lMap"
            :zoom="zoom"
            :center="mapCenter"
            :options="getMapOptions()"
            :min-zoom="5"
            :max-zoom="20"
            class="map-style"
            @overlayadd="overlayAdd"
            @overlayremove="overlayRemove"
            @baselayerchange="changeBaseLayer"
            @ready="initMap"
        >
            <l-control-zoom
                v-if="zoomVisible"
                position="bottomright"
            />
            <div
                ref="userposControl"
                class="leaflet-right leaflet-bottom leaflet-control"
                style="bottom: 80px; font-size: 18px"
            >
                <div
                    class="leaflet-touch leaflet-bar leaflet-control"
                >
                    <a
                        :class="{'bg-primary color-white': watchUserPositionId && !isLoadingPosition}"
                        style="width: 30px; height: 30px;"
                        @click="watchUserPosition"
                    >
                        <font-awesome-icon
                            icon="crosshairs"
                            :class="{pulse: isLoadingPosition}"
                        />
                    </a>
                    <a
                        v-if="watchUserPositionId && !isLoadingPosition"
                        style="width: 30px; height: 30px;"
                        @click="clearWatchUserPosition"
                    >
                        <font-awesome-icon icon="times" />
                    </a>
                </div>
            </div>
        </l-map>
        <div
            v-if="opacitySupported"
            ref="sliderControl"
            class="opacity-slider-container"
        >
            <map-layer-opacity-slider
                v-model:opacity-value="opacityValue"
                :min-opacity="minOpacity"
                :max-opacity="maxOpacity"
            />
        </div>
        <Transition name="fade">
            <div
                v-if="showInfo"
                class="map-info"
                :class="{top : infoOnTop}"
            >
                <map-info-table
                    class="map-info-content"
                    :fields="infoFields"
                    :data="infoContent"
                    :sensor-values="infoSensorValues"
                    :on-top="infoOnTop"
                    @click="hideMapInfoCallback"
                />
            </div>
        </Transition>
        <div
            v-if="contextMenuVisible"
            id="right-click-menu"
            :style="{ top: topMenu, left: leftMenu }"
        >
            <context-menu
                :menu-items="menuItems"
                @item-selected="menuItemClicked"
            />
        </div>
    </div>
</template>

<script>
import "leaflet/dist/leaflet.css"
import L from 'leaflet'
import {leafletVectorUtils} from "@/components/map/LeafletVectorUtils"
import "leaflet-polylinedecorator"
import 'leaflet-simple-map-screenshoter';
import 'leaflet-wms-header';
import 'leaflet.path.drag'
import 'protomaps-leaflet';
import resize from 'vue-resize-directive'
import MapInfoTable from './MapInfoTable'
import MapLayerOpacitySlider from '@/components/map/MapLayerOpacitySlider';
import {markRaw, toRaw} from 'vue';
import {mapHelper, userTracking} from '../mixins/MapMixin'
import "leaflet/dist/leaflet.css";
import {LControlZoom, LMap} from "@vue-leaflet/vue-leaflet";
import {restApi} from '../mixins/RestApiMixin';
import MapMarkerStorage from "@/components/map/MapMarkerStorage";
import ContextMenu from "@/components/utils/ContextMenu";
import clipboardCopy from 'clipboard-copy'
import {FontAwesomeIcon} from "@fortawesome/vue-fontawesome";

export default {
    name: 'LeafletMap',
    components: {FontAwesomeIcon, ContextMenu, LMap, MapInfoTable, LControlZoom, MapLayerOpacitySlider},
    directives: {
        resize
    },
    mixins: [mapHelper, restApi, userTracking, leafletVectorUtils],
    props: {
        menuItems: {
            type: Array,
            default: () => []
        },
        preferCanvas: {
            type: Boolean,
            default: true
        },
        center: {
            type: Object,
            default: null
        },
        findUser: {
            type: Boolean,
            default: function () {
                return false
            }
        },
        ignoreTraceTap: {
            type: Boolean,
            default: function () {
                return true
            }
        },
        isEditing: {
            type: Boolean,
            default: function () {
                return false
            }
        },
        menuEnabled: {
            type: Boolean,
            default: function () {
                return true
            }
        }
    },
    data: function () {
        return {
            map: null,
            dragging: false,
            mapBehavior: null,
            showInfo: false,
            contextMenuVisible: false,
            layerControlVisible: true,
            zoomVisible: true,
            currentCoordinates: null,
            contextCoordinates: null,
            clusterPolylinesVisible: false,
            polylineClusterZoomLevel: 11,
            infoOnTop: false,
            infoFields: null,
            markerStore: null,
            infoContent: [],
            infoSensorValues: [],
            polygons: [],
            polygonLines: [],
            videoRoutes: [],
            polylines: [],
            editablePolyline: null,
            polylineDecorators: [],
            polylineMapPoints: [],
            polylineBubbles: [],
            vehicleInfos: [],
            polygonLabels: [],
            markerLayers: [],
            endCircles: [],
            addLineEndIndicators: false,
            importedObjects: L.layerGroup(),
            geoLabels: {},
            equipmentGroup: null,
            zoomLevel: 0,
            observationGroup: new L.markerClusterGroup({
                spiderfyOnMaxZoom: false,
                showCoverageOnHover: false,
                disableClusteringAtZoom: 15,
                iconCreateFunction: function (cluster) {
                    return L.divIcon({  html: cluster.getChildCount() , className: 'cluster-observation general-cluster', iconSize: L.point(40, 40, true) });
                },
            }),
            storageGroup: new L.markerClusterGroup({
                spiderfyOnMaxZoom: false,
                showCoverageOnHover: false,
                disableClusteringAtZoom: 15,
                iconCreateFunction: function (cluster) {
                    return L.divIcon({  html: cluster.getChildCount() , className: 'cluster-storage general-cluster', iconSize: L.point(40, 40) });
                },
            }),
            stationGroup: new L.markerClusterGroup({
                spiderfyOnMaxZoom: false,
                showCoverageOnHover: false,
                disableClusteringAtZoom: 15,
                iconCreateFunction: function (cluster) {
                    return L.divIcon({  html: cluster.getChildCount() , className: 'cluster-station general-cluster', iconSize: L.point(40, 40) });
                },
            }),
            workAssignmentGroup: new L.markerClusterGroup({
                spiderfyOnMaxZoom: false,
                showCoverageOnHover: false,
                disableClusteringAtZoom: 15,
                iconCreateFunction: function (cluster) {
                    return L.divIcon({  html: cluster.getChildCount() , className: 'cluster-workAssignment general-cluster', iconSize: L.point(40, 40) });
                },
            }),
            streetLightsGroup: new L.markerClusterGroup({
                spiderfyOnMaxZoom: false,
                showCoverageOnHover: false,
                disableClusteringAtZoom: 15,
                iconCreateFunction: function (cluster) {
                    return L.divIcon({  html: cluster.getChildCount() , className: 'cluster-streetLight general-cluster', iconSize: L.point(40, 40) });
                },
            }),
            powerStationsGroup: new L.markerClusterGroup({
                spiderfyOnMaxZoom: false,
                showCoverageOnHover: false,
                disableClusteringAtZoom: 15,
                iconCreateFunction: function (cluster) {
                    return L.divIcon({  html: cluster.getChildCount() , className: 'cluster-powerStation general-cluster', iconSize: L.point(40, 40) });
                },
            }),
            trafficSignGroup: new L.markerClusterGroup({
                spiderfyOnMaxZoom: false,
                showCoverageOnHover: false,
                disableClusteringAtZoom: 17,
                iconCreateFunction: function (cluster) {
                    return L.divIcon({  html: cluster.getChildCount() , className: 'cluster-trafficSign general-cluster', iconSize: L.point(40, 40) });
                },
            }),
            mixedWasteBinGroup: new L.markerClusterGroup({
                spiderfyOnMaxZoom: false,
                showCoverageOnHover: false,
                disableClusteringAtZoom: 16,
                iconCreateFunction: function (cluster) {
                    return L.divIcon({  html: cluster.getChildCount() , className: 'cluster-mixedWasteBin general-cluster', iconSize: L.point(40, 40) });
                },
            }),
            stormDrainGroup: new L.markerClusterGroup({
                spiderfyOnMaxZoom: false,
                showCoverageOnHover: false,
                disableClusteringAtZoom: 15,
                iconCreateFunction: function (cluster) {
                    return L.divIcon({  html: cluster.getChildCount() , className: 'cluster-stormdrain general-cluster', iconSize: L.point(40, 40, true) });
                },
            }),
            userMarkerId: 1,
            anchorPointsGroup: null,
            editablePolygonLineStrings: null,
            editablePolylineStrings: null,
            topMenu: '0px',
            leftMenu: '0px',
            timer: null,
            cursorX: 0,
            cursorY: 0,
            mapCenter: {lat: 62.244207, lon: 25.748005},
            zoom: this.$store.state.mapZoomLevel,
            prevZoom: null,
            prevMapCenter: null,
            opacityValue: 10,
            minOpacity: 1,
            maxOpacity: 10,
            selectedOpacities: this.$store.state.mapSettings.leaflet && this.$store.state.mapSettings.leaflet.baseMapOpacityValues || [],
            blackIcon: null,
            lastBoundingBox: null,
            layerList: this.$store.state.mapSettings.leaflet && this.$store.state.mapSettings.leaflet.overlayList || [],
            baseMap: this.$store.state.mapSettings.leaflet && this.$store.state.mapSettings.leaflet.baseMap || 'Peruskartta',
            baseUrl: 'https://geodata.routaapi.com/ows?routa_env='+this.$store.state.mapEnv+'&map_key=' + this.$store.state.mapKey,
            layerReferences: [],
            geoJsonLayers: [],
            svgRenderer: null,
            canvasRenderer: null,
            layers: [
                {
                    name: 'Open Street Maps',
                    sourceType: "VECTOR",
                    visible: false,
                    dark: false,
                    url: 'https://tiles.eu.smartlas.sitowise.cloud/tiles/l/850/{z}/{x}/{y}?bag-map-token=',
                    defaultOpacity: 1,
                    maxNativeZoom: 14,
                    interactive: true,
                    type: "base"
                },
                {
                    name: 'Open Street Maps Dark',
                    sourceType: "VECTOR",
                    dark: true,
                    visible: false,
                    url: 'https://tiles.eu.smartlas.sitowise.cloud/tiles/l/850/{z}/{x}/{y}?bag-map-token=',
                    defaultOpacity: 1,
                    maxNativeZoom: 14,
                    interactive: true,
                    type: "base"
                },
                {
                    name: 'Peruskartta',
                    sourceType: "WMS",
                    visible: false,
                    format: 'image/png',
                    url: 'https://maps.bitcomp.com/geodata/common/ows',
                    layers: 'mml_taustakarttarasteri',
                    transparent: true,
                    opacity: 1,
                    defaultOpacity: 1,
                    maxNativeZoom: 17,
                    type: "base"
                },
                {
                    name: 'Maastokartta/ yhdistetty - MML',
                    sourceType: "WMS",
                    visible: false,
                    format: 'image/png',
                    url: 'https://maps.bitcomp.com/geodata/common/ows',
                    layers: 'mml_taustakarttayhdistelma',
                    transparent: true,
                    opacity: 1,
                    defaultOpacity: 1,
                    maxNativeZoom: 17,
                    type: "base"
                },
                {
                    name: 'Maastokartta - MML',
                    sourceType: "WMS",
                    visible: false,
                    format: 'image/png',
                    url: 'https://maps.bitcomp.com/geodata/common/ows',
                    layers: 'mml_maastokarttarasteri',
                    transparent: true,
                    opacity: 0.3,
                    defaultOpacity: 0.3,
                    maxNativeZoom: 17,
                    type: "base"
                },
                {
                    name: 'Ortoilmakuvat - MML',
                    sourceType: "WMS",
                    visible: false,
                    format: 'image/png',
                    url: 'https://maps.bitcomp.com/geodata/common/ows',
                    layers: 'mml_orto_rgb',
                    transparent: true,
                    opacity: 1,
                    defaultOpacity: 1,
                    maxNativeZoom: 17,
                    type: "base"
                },
                {
                    name: 'Vinovalo - MML',
                    sourceType: "WMS",
                    visible: false,
                    format: 'image/png',
                    url: 'https://maps.bitcomp.com/geodata/common/ows',
                    layers: 'mml_hillshade',
                    transparent: true,
                    opacity: 0.2,
                    maxNativeZoom: 17,
                    type: "overlay",
                },
                {
                    name: 'Kiinteistörajat - MML',
                    sourceType: "WMS",
                    visible: false,
                    format: 'image/png',
                    url: 'https://maps.bitcomp.com/geodata/common/ows',
                    layers: 'mml_parcel_polygon',
                    transparent: true,
                    type: "overlay",
                    opacity: 1,
                    maxNativeZoom: 17
                },
                {
                    name: 'Kiinteistötunnus - MML',
                    sourceType: "WMS",
                    visible: false,
                    format: 'image/png',
                    url: 'https://maps.bitcomp.com/geodata/common/ows',
                    layers: 'mml_parcel_reference_point',
                    transparent: true,
                    type: "overlay",
                    opacity: 1,
                    maxNativeZoom: 17
                },
                /*
                {
                    name: 'Metsäautotiet - omatoiminen ylläpito',
                    sourceType: "WMS",
                    visible: false,
                    format: 'image/png',
                    url: 'https://maps.bitcomp.com/geodata/common/ows',
                    layers: 'routa_mh_jatkuvayllapito_alueurakointi',
                    transparent: true,
                    type: "overlay",
                    opacity: 1,
                    maxNativeZoom: 15
                },
                {
                    name: 'Metsäautotiet - Hall.luokitus',
                    sourceType: "WMS",
                    visible: false,
                    format: 'image/png',
                    url: 'https://maps.bitcomp.com/geodata/common/ows',
                    layers: 'routa_mh_tiet_koko_maa',
                    transparent: true,
                    type: "overlay",
                    opacity: 1,
                    maxNativeZoom: 15
                },
                {
                    name: 'Metsäautotiet - Kantavuus',
                    sourceType: "WMS",
                    visible: false,
                    url: 'https://maps.bitcomp.com/geodata/common/ows',
                    format: 'image/png',
                    layers: 'routa_mh_tiet_kantavuus_koko_maa',
                    transparent: true,
                    type: "overlay",
                    opacity: 1,
                    maxNativeZoom: 15
                },
                {
                    name: 'Talvitiet',
                    sourceType: "WMS",
                    visible: false,
                    url: 'https://maps.bitcomp.com/geodata/common/ows',
                    format: 'image/png',
                    layers: 'routa_mh_talvitiet',
                    transparent: true,
                    type: "overlay",
                    opacity: 1,
                    maxNativeZoom: 15
                }
                */
                {
                    name: 'Pohjavesialueet',
                    sourceType: "WMS",
                    visible: false,
                    format: 'image/png',
                    url: 'https://maps.bitcomp.com/geodata/common/ows',
                    layers: 'syke_groundwater_area',
                    transparent: true,
                    type: "overlay",
                    opacity: 0.7,
                    maxNativeZoom: 15
                },
            ],
            attribution: 'Sitowise & Maanmittauslaitos',
            showMap: true,
            simpleScrenshooter: null,
            accessToken: '',
            mapToken: this.$store.state.geoDataMapToken ?? ''
        }
    },

    computed: {
        clusteredPolylines() {
            return [this.OBSERVATION, this.WORK_ASSIGNMENT]
        },
        opacitySupported() {
            let layer = this.layerReferences[this.baseMap]
            return layer && 'setOpacity' in layer
        }
    },
    inject: ['appVisible'],
    watch: {
        appVisible: {
            immediate: true,
            handler(isVisible) {
                if (isVisible) {
                    this.resizeMap()
                }
            }
        },
        center: function () {
            this.centerMap()
        },
        zoomLevel: function (value) {
            if (this.clusterPolylinesVisible && value < this.polylineClusterZoomLevel) {
                this.clusterPolylinesVisible = false
                this.handleClusterLines(this.clusterPolylinesVisible)
            } else if (!this.clusterPolylinesVisible && value >= this.polylineClusterZoomLevel) {
                this.clusterPolylinesVisible = true
                this.handleClusterLines(this.clusterPolylinesVisible)
            }
        },

        opacityValue() {
            let layer = this.layerReferences[this.baseMap]
            if (layer && 'setOpacity' in layer) {
                let foundOpacityIndex = this.selectedOpacities.findIndex(item => item.name === layer.name)
                if(foundOpacityIndex !== -1) {
                    this.selectedOpacities.splice(foundOpacityIndex, 1)
                }
                if (layer.defaultOpacity !== this.opacityValue/10) {
                    this.selectedOpacities.push({name: layer.name, value: this.opacityValue/10})
                    this.updateMapSettings({ leaflet: { baseMapOpacityValues: this.selectedOpacities } })
                    this.saveMapSettings()
                }
                layer.setOpacity(this.opacityValue/10)
            }
        }
    },

    created() {
        this.accessToken = this.$store.state.geoDataToken ?? ''
        this.mapToken = this.$store.state.geoDataMapToken ?? ''
    },

    mounted() {
        this.markerStore = new MapMarkerStorage()
        // TODO - Remove commented code if skipping this does not cause issues
        /*
        let resizeRaf = null
        this._resizeObserver = new ResizeObserver(() => {
            if (resizeRaf) cancelAnimationFrame(resizeRaf)
            resizeRaf = requestAnimationFrame(() => {
                this.map?.resizeMap()
            })
        })
        this._resizeObserver.observe(this.$el)
         */
    },

    beforeUnmount() {
        if (this._resizeObserver) this._resizeObserver.disconnect()
        this.removeGeoJsonLayers()
        this.hideGeoJsonObjects()
    },

    methods: {

        centerMap() {
            if (this.map && this.center) {
                this.mapCenter = this.center
                if(this.mapCenter.y && this.mapCenter.x) {
                    this.zoomToPosition(this.mapCenter.y, this.mapCenter.x, this.prevZoom)
                } else if(this.mapCenter.lat && this.mapCenter.lng) {
                    this.zoomToPosition(this.mapCenter.lat, this.mapCenter.lng, this.prevZoom)
                }
            }
        },

        getMapOptions() {
            return {
                zoomSnap: 0.25,
                zoomControl: false,
                preferCanvas: this.preferCanvas || false,
            }
        },

        getMarkerStore() {
            return this.markerStore
        },

        handleClusterLines(show) {
            this.clusteredPolylines.forEach((polyline) => {
                if (this.polylines[polyline]) {
                    this.polylines[polyline].forEach(polyline1 => {
                        if (show) {
                            polyline1.addTo(this.map)
                        } else {
                            polyline1.remove()
                        }
                    })
                }
            })
        },

        safePatchUpdatePosition(klass) {
            if (!klass?.prototype?._updatePosition) return;
            const original = klass.prototype._updatePosition;
            klass.prototype._updatePosition = function (...args) {
                if (!this._map || !this._latlng) return;
                try {
                    original.call(this, ...args);
                } catch (err) {
                    console.warn(`[SAFE _updatePosition] Suppressed error in ${this.constructor.name}`, err);
                }
            };
        },

        safePatchAnimateZoom(klass) {
            if (!klass?.prototype?._animateZoom) return;

            const original = klass.prototype._animateZoom;
            klass.prototype._animateZoom = function (e) {
                if (!this._map || !this._map._latLngToNewLayerPoint) return;
                try {
                    if (this._latlng) {
                        const pos = this._map._latLngToNewLayerPoint(this._latlng, e.zoom, e.center).round();
                        this._setPos?.(pos);
                    } else {
                        original.call(this, e);
                    }
                } catch (err) {
                    console.warn(`[SAFE _animateZoom] Suppressed error in ${this.constructor.name}`, err);
                }
            };
        },



        initMap: function (mapInstance) {
            this.map = mapInstance
            this.map.addEventListener('mousemove', this.pointerMove)
            this.map.addEventListener('click', this.mapClicked)
            const storedZoom = this.$store.state.mapZoomLevel;
            this.prevMapCenter = mapInstance.getCenter()

            if (storedZoom) {
                mapInstance.setZoom(storedZoom)
                this.prevZoom = storedZoom
            } else {
                this.prevZoom = mapInstance.getZoom()
            }

            this.mapMoveEnd()
            this.checkStoredBaseMap()
            this.checkStoredOverlays()
            this.updateOpacityValue()
            this.simpleScrenshooter = L.simpleMapScreenshoter(this.leafletScreenshotOptions).addTo(this.map)
            this.addLayers()
            this.clusterLayers()
            this.centerMap()

            // Code the work-around zoom crash - should polyline have one as well?
            const classes = [
                L.Marker,
                L.CircleMarker,
                L.Circle,
                L.Polyline,
                L.Tooltip,
                L.Popup,
                L.markerClusterGroup,
            ]
            classes.forEach(klass => {
                this.safePatchAnimateZoom(klass);
                this.safePatchUpdatePosition(klass);
            });

            // Initialize panes
            this.map.createPane('geojsonPane');
            this.map.getPane('geojsonPane').style.zIndex = 500;
            this.map.getPane('geojsonPane').style.pointerEvents = 'stroke';

            this.map.createPane('polylinePane');
            this.map.getPane('polylinePane').style.zIndex = 550;
            this.map.getPane('polylinePane').style.pointerEvents = 'stroke';

            this.map.createPane('markerPane');
            this.map.getPane('markerPane').style.zIndex = 600;
            this.map.getPane('markerPane').style.pointerEvents = 'auto';

            // Create renderers
            this.svgRenderer = L.svg()
            this.canvasRenderer = L.canvas({ padding: 0.5 });

            this.$nextTick(() => this.$emit('mapReady'))
        },

        addLayers() {
            const layerControl = L.control.layers(null, null, {
                position: 'bottomleft' // Set the position to bottom left
            }).addTo(this.map);
            this.layers.forEach(layer => {
                if (layer.sourceType === "WMS") {
                    this.addWmsLayer(layerControl, layer)
                }
                if (layer.sourceType === "VECTOR") {
                    this.addVectorLayer(layerControl, layer)
                }
            });
        },

        addWmsLayer(layerControl, layer) {
            let wmsLayer = L.TileLayer.wmsHeader(
                layer.url,
                {
                    layers: layer.layers,
                    format: layer.format,
                    transparent: layer.transparent,
                    visible: layer.visible,
                    opacity: layer.opacity,
                    maxZoom: 20,
                    maxNativeZoom: layer.maxNativeZoom,
                    updateWhenZooming: false,
                    updateWhenIdle: true
                }, [
                    { header: 'Authorization', value: 'Basic ' + this.accessToken },
                ],
                null
            )
            if (layer.type === "base") {
                layerControl.addBaseLayer(wmsLayer, layer.name);
            } else {
                layerControl.addOverlay(wmsLayer, layer.name);
            }
            if (layer.visible) {
                wmsLayer.addTo(this.map)
            }

            // Try to prevent huge tile loading during zooming
            const originalUpdate = wmsLayer._update;
            let updateTimer = null;
            wmsLayer._update = function () {
                clearTimeout(updateTimer);
                updateTimer = setTimeout(() => {
                    originalUpdate.call(this);
                }, 300);
            };

            this.layerReferences[layer.name] = wmsLayer;
        },

        addVectorLayer(layerControl, layerInfo) {
            try {
                const dark = layerInfo.dark
                /* eslint-disable-next-line */
                var layer = protomapsL.leafletLayer({
                    url: layerInfo.url + this.mapToken,
                    paintRules: dark ? this.getDarkPaintRules() : this.getPaintRules(),
                    labelRules: dark ? this.getDarkLabelRules() : this.getLabelRules(),
                    maxDataZoom: 14,
                    attribution: 'Open Street Maps | Sitowise Smartlas',
                    backgroundColor: dark ? '#626865' : '#F4EFE1',
                    updateWhenZooming: false,
                    updateWhenIdle: true
                })
                // Try to prevent huge tile loading during zooming
                const originalUpdate = layer._update;
                let updateTimer = null;
                layer._update = function () {
                    clearTimeout(updateTimer);
                    updateTimer = setTimeout(() => {
                        originalUpdate.call(this);
                    }, 300);
                };

                layerControl.addBaseLayer(layer, layerInfo.name);
                if (layerInfo.visible) {
                    layer.addTo(this.map)
                }
                this.layerReferences[layer.name] = layer
            } catch (error) {
                // eslint-disable-next-line
                console.error("Error in protomaps layer creation. Service might be down.",  error.message)
            }
        },


        /**
         * @return Screenshot of map as a blob
         **/
        takeScreenShot() {
            return new Promise((resolve, reject) => {
                let format = 'blob' // 'image' - return base64, 'canvas' - return canvas
                let overridedPluginOptions = {
                    mimeType: 'image/jpeg',
                    hideElementsWithSelectors: ['.leaflet-control-container'], //Todo hide location selector button
                }
                this.simpleScrenshooter.takeScreen(format, overridedPluginOptions)
                    .then(blob => {
                        resolve(blob);
                    })
                    .catch(error => {
                        reject(error);
                    });
            });
        },

        clusterLayers() {
            this.map.addLayer(this.observationGroup);
            this.map.addLayer(this.workAssignmentGroup);
            this.map.addLayer(this.storageGroup);
            this.map.addLayer(this.stationGroup);
            this.map.addLayer(this.streetLightsGroup);
            this.map.addLayer(this.powerStationsGroup);
            this.map.addLayer(this.trafficSignGroup);
            this.map.addLayer(this.mixedWasteBinGroup);
            this.map.addLayer(this.stormDrainGroup);
        },

        checkStoredBaseMap: function () {
            let baseMap = this.layers.find(item => item.name === this.baseMap)
            if (baseMap) {
                baseMap.visible = true
            } else {
                this.layers.find(item => item.name === 'Peruskartta').visible = true
            }
        },

        checkStoredOverlays: function () {
            this.layers.forEach(layer => {
                if(this.layerList.includes(layer.name) && layer.type === 'overlay') {
                    layer.visible = true
                }
            })
        },

        changeBaseLayer: function (layer) {
            this.updateMapSettings({ leaflet: { overlayList: this.layerList, baseMap: layer.name } })
            this.saveMapSettings()
            this.updateBaseMap(layer)
            this.updateOpacityValue()
        },

        updateOpacityValue: function () {
            let layer = this.layers.find(layer => layer.name === this.baseMap)
            if (layer && layer.sourceType ==="WMS") {
                let foundOpacity = this.selectedOpacities.find(layer => layer.name === this.baseMap)
                if(foundOpacity){
                    this.opacityValue = foundOpacity.value*10
                } else {
                    this.opacityValue = this.layers.find(layer => layer.name === this.baseMap).opacity ?
                        this.layers.find(layer => layer.name === this.baseMap).opacity*10 : 10
                }
            }
        },

        updateBaseMap: function(layer) {
            this.baseMap = layer.name
        },

        overlayAdd: function(layer) {
            this.layerList.push(layer.name)
            this.updateMapSettings({ leaflet: { overlayList: this.layerList } })
            this.saveMapSettings()
        },

        overlayRemove: function(layer) {
            this.layerList = this.layerList.filter(layerName => layerName !== layer.name)
            this.updateMapSettings({ leaflet: { overlayList: this.layerList } })
            this.saveMapSettings()
        },

        getMapCenter: function () {
            return this.map.getCenter();
        },

        getViewBounds() {
            return this.map.getBounds()
        },

        getMapZoomLevel: function () {
            this.zoomLevel = this.map.getZoom()
            return this.map.getZoom()
        },

        mousemove: function (event) {
            this.cursorX = event.clientX
            this.cursorY = event.clientY
        },
        touchmove: function (event) {
            this.cursorX = event.touches[0].clientX
            this.cursorY = event.touches[0].clientY
        },

        mapMoveEnd() {
            this.map.on('moveend', (event) => {
                const newMapCenter = event.target.getCenter();
                const newZoomLevel = event.target.getZoom();
                if (newZoomLevel !== this.prevZoom) {
                    this.prevZoom = newZoomLevel;
                    clearTimeout(this.timer);
                    this.timer = setTimeout(() => {
                        this.$emit('onZoomLevelChange', newZoomLevel)
                    }, 1500);
                } else if (this.prevMapCenter && (newMapCenter.lat !== this.prevMapCenter.lat || newMapCenter.lng !== this.prevMapCenter.lng)) {
                    const bbox = this.getViewBoundsCoordinates()
                    if (this.hasBoundingBoxChanged(bbox)) {
                        this.lastBoundingBox = bbox
                        this.prevMapCenter = newMapCenter
                        clearTimeout(this.timer);
                        this.timer = setTimeout(() => {
                            this.$emit('onBoundingBoxChange', bbox)
                        }, 1500);
                    }
                }
            });
        },

        hasBoundingBoxChanged(bbox) {
            if (!this.lastBoundingBox) return true
            return this.lastBoundingBox[0] !== bbox[0] ||
                this.lastBoundingBox[1] !== bbox[1] ||
                this.lastBoundingBox[2] !== bbox[2] ||
                this.lastBoundingBox[3] !== bbox[3]
        },

        mapClicked: function (evt) {
            if (this.contextMenuVisible) {
                this.contextMenuVisible = false
            } else {
                this.$emit('onMapClicked', evt.latlng)
            }
        },

        openMenu: function (event) {
            if (!this.dragging) {
                this.openMenuXY(event.x, event.y)
                event.preventDefault()
            }
        },

        openMenuXY: function (x, y) {
            if (this.menuEnabled && this.menuItems && this.menuItems.length > 0) {
                this.contextCoordinates = this.currentCoordinates
                this.contextMenuVisible = true
                this.$nextTick(function () {
                    this.$refs['map-canvas'].focus()
                    this.showContextMenu(y, x)
                }.bind(this))
            }
        },

        showContextMenu: function (top, left) {
            let largestHeight = window.innerHeight - 240
            let largestWidth = window.innerWidth - 260
            if (top > largestHeight) {
                top = largestHeight
            }
            if (left > largestWidth) {
                left = largestWidth
            }
            this.topMenu = top + 'px'
            this.leftMenu = left + 'px'
        },

        pointerMove: function (event) {
            if(this.currentCoordinates !== event.latlng) {
                this.$emit('pointerCoordinateMove', event.latlng);
            }
            this.currentCoordinates = event.latlng
        },

        hideContextMenu: function () {
            this.contextMenuVisible = false
        },

        copyCoordinates: function () {
            clipboardCopy(this.contextCoordinates.lat + ' ' + this.contextCoordinates.lng)
            this.hideContextMenu()
        },

        menuItemClicked(callback) {
            this.hideContextMenu()
            callback(this.contextCoordinates)
        },

        zoomToPosition: function (lat, lon, zoom) {
            this.map.invalidateSize()
            this.map.setView(new L.LatLng(lat, lon), zoom)
        },

        /**
       * Zooms the view to show all the objects in the group
       * @param groupId to specify a group to add the map object to
       **/
        zoomToGroup: function(type, maxZoom = 15) {
            if (this.markerLayers?.[type]) {
                const bounds = this.markerLayers[type].getBounds()
                if (bounds.isValid()) {
                    this.map.fitBounds(bounds, { padding: [50, 50] })
                }
            }
            else if (this.polylines[type] != null) {
                let lines = []
                let keys = Object.keys(this.polylines[type])
                for (let i = 0; i < keys.length; i++) {
                    lines.push(this.polylines[type][keys[i]])
                }
                let group = new L.featureGroup(lines);
                this.map.fitBounds(group.getBounds(), { padding: [50, 50] });
                if (maxZoom && this.map.getZoom() > maxZoom) {
                    this.setMapZoomLevel(maxZoom)
                }
            } else if (this.polygons[type] != null) {
                let areas = []
                let keys = Object.keys(this.polygons[type])
                for (let i = 0; i < keys.length; i++) {
                    areas.push(this.polygons[type][keys[i]])
                }
                let group = new L.featureGroup(areas);
                this.map.fitBounds(group.getBounds(), { padding: [50, 50] });
                if (maxZoom && this.map.getZoom() > maxZoom) {
                    this.setMapZoomLevel(maxZoom)
                }
            }
        },

        async resizeMap () {
            if (this.map) {
                this.map.invalidateSize()
            }
        },

        setMapZoomLevel: function (zoom) {
            this.zoom = zoom
            this.map.setZoom(zoom)
        },

        showUserPosition: function () {
            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(pos => {
                    if (this.map) {
                        this.showPosition(pos, true, this.watchUserPositionId != null)
                    }
                }, () => {
                }, {timeout: 30000, enableHighAccuracy: true})
            }
        },

        /** Zoom to user location and show user position marker */
        showPosition: function (position, removeMarker = true, zoomToPos = false) {
            if (position) {
                const { latitude, longitude } = position.coords;
                if (zoomToPos) {
                    this.zoomToPosition(latitude, longitude)
                }
                if (removeMarker) {
                    this.showUserMarker(latitude, longitude)
                }
            }
        },

        showUserMarker: function (lat, lon) {
            if (!lat || !lon) return
            this.removeMapMarker(this.userMarkerId, this.USER_LOCATION)
            this.showMapMarker(this.userMarkerId, this.USER_LOCATION, lat, lon, this.markerStore.getUserMarkerIcon())
        },

        addEquipmentMarkers: function (equipmentList) {
            this.equipmentGroup = L.layerGroup();
            this.equipmentGroup.addTo(this.map);
            equipmentList.forEach(function (equipment) {
                this.removeMapMarker(equipment.id, this.EQUIPMENT)
                this.equipmentMarkerInfo(equipment, this.markerStore.getSimpleEquipmentIcon());
            }.bind(this))
        },

        addEquipmentMarker: function (equipment) {
            this.showMapMarker(equipment.id, this.EQUIPMENT, equipment.location.y, equipment.location.x,
                this.markerStore.getSimpleEquipmentIcon(), false)
            this.zoomToPosition(equipment.location.y, equipment.location.x, 16)
        },

        addDraggableEquipmentMarker: function (equipment) {
            this.showMapMarker(equipment.id, this.EQUIPMENT, equipment.location.y, equipment.location.x,
                this.markerStore.getSimpleEquipmentIcon(), true)
            this.zoomToPosition(equipment.location.y, equipment.location.x, 18)
        },

        equipmentMarkerInfo: function (equipment, iconElement) {
            let icon = L.divIcon({
                html: iconElement,
                className: 'dummy'
            })
            let marker = L.marker([equipment.location.y, equipment.location.x], {
                zIndexOffset: 5,
                icon: icon,
            })
            this.equipmentGroup.addLayer(marker)
            let manufacturer = equipment.manufacturer ? equipment.manufacturer : '-'
            let description = equipment.description ? equipment.description : '-'
            marker.bindPopup(
                '<div>' +
                    '<div class="leaflet-bubble-text">' + equipment.name + '</div>' +
                    '<div><div class="col-sm-12  nopads leaflet-bubble-title">' + this.$t('equipment.manufacturer') + ':</div><div class="col-sm-12 leaflet-bubble-content-text nopads">' + manufacturer + '</div></div>' +
                    '<div><div class="col-sm-12  nopads leaflet-bubble-title">' + this.$t('equipment.description') + ':</div><div class="col-sm-12 leaflet-bubble-content-text nopads">' + description + '</div></div>' +
                    '</div>'
            )
        },

        /**
         * Draws a polyline on the map. The Id given needs to be unique,
         * e.g. from database or some random for others
         * @param id a unique id for the polyline
         * @param points coordinates for the line in format [{x: 25, y: 62}]
         * @param color of the line
         * @param dash use dashed line
         * @param type integer that refers to the group of polylines, used e.g. in toggling visibility
         * @param arrows
         * @param lineWidth
         * @param transparency
         * @param lineStartPoint
         * @param closed
         * @param externalId
         **/
        // eslint-disable-next-line
        drawPolyLine: function (
            id,
            type,
            points,
            color,
            dash = false,
            arrows = false,
            lineWidth = 4,
            transparency = 1,
            lineStartPoint = false,
            closed = false,
            externalId = null,
            bringBack = false
        ) {
            if (!this.map) return;

            // Remove old polyline if exists
            this.removePolyline(id, type);
            if (!this.polylines[type]) this.polylines[type] = [];

            if (!points || points.length === 0) return;

            const mappoints = points.map(p => [p.y, p.x]);
            const dashPattern = Math.max(4, lineWidth + 4);

            // --- Create the polyline ---
            const polyline = L.polyline(mappoints, {
                color,
                weight: lineWidth,
                opacity: transparency,
                dashArray: dash ? [dashPattern, dashPattern] : null,
                pane: 'polylinePane',
                renderer: this.svgRenderer,
                interactive: true,
                bubblingMouseEvents: true
            });

            // --- Attach identifying info ---
            polyline.lineData = externalId
                ? { id: externalId, type }
                : { id, type };

            // --- Attach event listeners ---
            polyline.on('mouseover', this.polylineHoverEvent);
            polyline.on('mouseout', this.polylineHoverExitEvent);
            //polyline.on('mousemove', this.polylineHoverEvent);
            polyline.on('click', this.generalTapEvent);

            // --- Add to map (if not clustered) ---
            if (
                !this.clusteredPolylines.includes(type) ||
                this.map.getZoom() >= this.polylineClusterZoomLevel
            ) {
                polyline.addTo(this.map);
            }

            // Optionally bring to back
            if (bringBack) {
                polyline.bringToBack()
            }

            // --- Optionally mark the start point ---
            if (lineStartPoint) {
                this.showPolylineStartPoint(id, type, points, closed);
            }

            // --- Store reference ---
            this.polylines[type][id] = toRaw(polyline);
        },

        /**
         * Restyle an already-drawn polyline in place (weight/color/opacity) and
         * optionally bring it to the front, without redrawing it. Mirrors the
         * highlight-on-hover pattern used in the route optimization simulation.
         * No-ops if the polyline does not exist. Only changes the given style
         * keys.
         * @param id polyline id
         * @param type polyline type
         * @param style Leaflet path style object (e.g. { weight: 5 })
         * @param bringToFront when true, raises the polyline above its siblings
         */
        setPolylineStyle: function (id, type, style, bringToFront = false) {
            const polyline = this.polylines[type] ? this.polylines[type][id] : null
            if (!polyline || typeof polyline.setStyle !== 'function') return
            polyline.setStyle(style)
            if (bringToFront && typeof polyline.bringToFront === 'function') {
                polyline.bringToFront()
            }
        },

        showPolylineStartPoint: function (id, type, points, closed = false) {
            if (!this.polylineMapPoints[type]) {
                this.polylineMapPoints[type] = []
            }
            if (!this.polylineMapPoints[type][id]) {
                this.polylineMapPoints[type][id] = []
            }
            if (points) {
                let icon = L.divIcon({
                    html: closed ? this.markerStore.getPolylinePointClosedIcon() : this.markerStore.getPolylinePointIcon(),
                    className: 'dummy'
                });
                let marker = L.marker([points[0].y, points[0].x], {
                    zIndexOffset: 5,
                    icon: icon,
                    draggable: false,
                    autoPan: false
                })
                if (type === this.OBSERVATION) {
                    marker.addTo(toRaw(this.observationGroup))
                } else {
                    marker.addTo(this.map);
                }
                marker.markerData = {id: id, type: type}
                marker.addEventListener('mouseover', this.markerPointerEnterEvent)
                marker.addEventListener('click', this.markerTapEvent)
                this.polylineMapPoints[type][id] = marker
            }
        },

        removePolylinePointsByType: function (type) {
            if (type && this.polylineMapPoints[type]) {
                this.polylineMapPoints[type].forEach(item => item.remove())
                this.polylineMapPoints[type] = []
            }
        },


        removePolylinePoints: function (type, id) {
            if (type && this.polylineMapPoints[type] && id && this.polylineMapPoints[type[id]]) {
                this.polylineMapPoints[type][id].remove()
                this.polylineMapPoints[type][id] = []
            }
        },

        hidePolylineBubble: function (id, type) {
            if (this.polylineBubbles[type] && this.polylineBubbles[type][id]) {
                this.map.removeLayer(this.polylineBubbles[type][id])
                this.polylineBubbles[type][id] = undefined
            }
        },

        showPolylineBubble: function (id, type, posY, posX, title, values) {
            if (!this.polylineBubbles[type] || !this.polylineBubbles[type][id] || !this.polylineBubbles[type][id].isOpen()) {
                if (!this.polylineBubbles[type]) {
                    this.polylineBubbles[type] = []
                }
                this.polylineBubbles[type][id] = null
                let content = '<div>' + '<div class="leaflet-bubble-text">' + title + '</div>'
                values.forEach(item => {
                    content += '<div><div class="col-sm-12  nopads leaflet-bubble-title">' + item.name + ':</div><div class="col-sm-12 leaflet-bubble-content-text nopads" style="color: #404041">' + item.value + '</div></div>'
                })
                content += '</div>'
                var popup = L.popup({closeButton: true, autoPan: false, closeOnClick: false});
                popup.setLatLng(L.latLng(posY, posX));
                popup.setContent(content);
                this.map.addLayer(popup);
                this.polylineBubbles[type][id] = popup
                // popup.openOn(this.map);
            }
        },


        /**
         * Removes a polyline from the map
         * @param id of the line to be removed
         * @param type
         **/
        removePolyline: function (id, type) {
            if (this.polylines[type]) {
                var polyline = this.polylines[type][id]
                if (polyline) {
                    polyline.remove(this.map)
                    this.polylines[type][id] = undefined
                    this.removePolylinePoints(type, id)
                }
            }
        },

        removePolylinesByType: function (type) {
            if (type && this.polylines[type]) {
                this.polylines[type].forEach(function (polyline) {
                    if (polyline) {
                        polyline.remove(this.map)
                    }
                }, this)
                this.polylines[type] = []
            }
            this.removePolylineStartPointsByType(type)
        },

        removePolylineStartPointsByType: function (type) {
            if (this.polylineMapPoints[type]) {
                this.polylineMapPoints[type].forEach(function (point) {
                    point.remove()
                }, this)
                this.clearClusterByType(type)
                this.polylineMapPoints[type] = []
            }
        },

        removePolygonsByType: function (type) {
            if (type && this.polygons[type]) {
                this.polygons[type].forEach(function (polygon) {
                    polygon.remove(this.map)
                }, this)
                this.polygons[type] = []
            }
        },

        removeAllLineEndIndicators() {
            if (this.endCircles && this.endCircles.length > 0) {
                for (let i = 0; i < this.endCircles.length; i++) {
                    this.map.removeLayer(this.endCircles[i]);
                }
                this.endCircles = [];
            }
        },

        addPolylineEndIndicators(geoJSONFeature, color) {
            // Get the coordinates of the LineString feature
            const pointsArray = geoJSONFeature.geometry.coordinates;

            // Define the center of the circles
            const startCenter = { lat: pointsArray[0][1], lng: pointsArray[0][0] };
            const endCenter = { lat: pointsArray[pointsArray.length - 1][1], lng: pointsArray[pointsArray.length - 1][0] };

            // Create a new circle object for each endpoint
            let solidCircleIcon = this.markerStore.getSolidCircleIcon()
            let iconDiv = this.markerStore.getAsDivElement(solidCircleIcon)
            this.markerStore.setIconStyleProperty(iconDiv, 'color', color)
            // iconDiv.style.color = color
            solidCircleIcon = iconDiv.outerHTML

            let icon = L.divIcon({
                html: solidCircleIcon,
                className: 'dummy'
            });
            let startCircle = L.marker(startCenter, {
                zIndexOffset: 5,
                icon: icon,
                draggable: false,
                autoPan: false
            })

            let endCircle = L.marker(endCenter, {
                zIndexOffset: 5,
                icon: icon,
                draggable: false,
                autoPan: false
            })

            // Add the circles to the map
            this.endCircles.push(startCircle);
            this.endCircles.push(endCircle);
            startCircle.addTo(this.map);
            endCircle.addTo(this.map);
        },

        removeMapItemsByType: function (type) {
            this.removePolylinesByType(type)
            this.removePolygonsByType(type)
            this.removeMapMarkerByType(type)
            this.removePolylinePointsByType(type)
        },

        /**
         * Emits a hover event with the id of the hovered polyline
         * @param e contains the data of the polyline, usually id of the polyline
         **/
        polylineHoverEvent: function (e) {
            const mousePoint = this.map.latLngToContainerPoint(e.latlng)
            const tolerance = 8 // px

            const hits = []

            Object.values(this.polylines).forEach(group => {
                Object.values(group).forEach(polyline => {
                    if (!polyline || !polyline.getLatLngs) {
                        return
                    }

                    const latLngs = polyline.getLatLngs()
                    let minDistance = Infinity

                    for (let i = 0; i < latLngs.length - 1; i++) {
                        const p1 = this.map.latLngToContainerPoint(latLngs[i])
                        const p2 = this.map.latLngToContainerPoint(latLngs[i + 1])

                        const distance = L.LineUtil.pointToSegmentDistance(
                            mousePoint,
                            p1,
                            p2
                        )

                        minDistance = Math.min(minDistance, distance)
                    }

                    if (minDistance <= tolerance) {
                        const index = this.getNearestLatLngIndex(
                            e.latlng,
                            latLngs
                        )

                        hits.push({
                            lineData: polyline.lineData,
                            latlng: e.latlng,
                            index: index,
                            distance: minDistance,
                            polyline: polyline
                        })
                    }
                })
            })
            if (hits.length < 2) {
                const index = this.getNearestLatLngIndex(e.latlng, e.sourceTarget.getLatLngs())
                this.$emit('onPolylineHover', e.target.lineData, e.latlng, index)
            } else {
                this.$emit('onPolylinesHovered', hits, e.latlng)
            }
        },

        getNearestLatLngIndex(latlng, latlngs) {
            let nearestIndex = -1;
            let shortestDistance = Infinity;

            latlngs.forEach(function(ll, index) {
                const distance = latlng.distanceTo(L.latLng(ll));
                if (distance < shortestDistance) {
                    shortestDistance = distance;
                    nearestIndex = index;
                }
            });
            return nearestIndex;
        },

        /**
         * Emits a hover exit event
         **/
        polylineHoverExitEvent: function (e) {
            this.$emit('onPolylineHoverExit', e.target.lineData)
        },

        /**
         * Shows map info view (table) on top of the map with given fields and content
         * @param infoFields are the table headers
         * @param infoContent is the data for the table
         **/
        showMapInfo: function (infoFields, infoContent, onTop, sensorValues = []) {
            this.infoFields = infoFields
            this.infoContent = infoContent
            this.infoSensorValues = sensorValues
            this.showInfo = true
            this.infoOnTop = onTop
        },

        /**
         * Hides the map info view and sends callback
         **/
        hideMapInfoCallback: function () {
            this.hideMapInfo()
            this.$emit('onMapInfoClosed')
        },

        /**
         * Hides the map info view
         **/
        hideMapInfo: function () {
            this.infoFields = []
            this.infoContent = []
            this.infoSensorValues = []
            this.showInfo = false
        },

        /**
         * Creates a new area polygon and ads it on the map
         * @param id is a unique identifier for the polygon, e.g. database id
         * @param lat latitude coordinate
         * @param lng longitude coordinate
         * @param type integer that refers to the group of polygons, used e.g. in toggling visibility
         **/
        newPolygon: function (id, lat, lng, type = this.AREA) {
            let polygon = L.polygon([[lat, lng]], {
                color: '#219ade',
                fillColor: '#219ade',
                opacity: 0.5,
                weight: 4
            });
            if(!this.polygons[type]) this.polygons[type] = []
            this.polygons[type][id] = polygon;
            polygon.addTo(this.map);

        },

        /**
         * Adds a point to a polygon. The added point will be the last point.
         * @param id is a unique identifier for the polygon, e.g. database id
         * @param lat latitude coordinate
         * @param lng longitude coordinate
         * @param type integer that refers to the group of polygons, used e.g. in toggling visibility
         **/
        addPointToPolygon: function (id, lat, lng, type = this.AREA) {
            if(!this.polygonLines[type]) this.polygonLines[type] = []
            this.polygons[type][id].addLatLng(L.latLng(lat, lng))
        },

        /**
         * Creates a new area polyline and ads it on the map
         * @param type of the polyline defines to which group of data it belongs (observations, trace etc).
         * @param id is a unique identifier for the polyline, e.g. database id
         * @param lat latitude coordinate
         * @param lng longitude coordinate
         **/
        newPolyLine: function (type, id, lat, lng) {
            let polyline = L.polyline([[lat, lng]], {
                color: '#219ade',
                fillColor: '#219ade',
                opacity: 0.5,
                weight: 4
            });
            if (!this.polylines[type]) {
                this.polylines[type] = []
            }
            this.polylines[type][id] = polyline;
            polyline.addTo(this.map);
        },

        addEditablePolyline(coordinates) {
            const leafletCoords = coordinates.map(c => [c[1], c[0]]);
            // --- Create the polyline ---
            const color = '#000000'
            this.editablePolyline = L.polyline(leafletCoords, {
                color,
                weight: 4,
                opacity: 0.7,
                pane: 'polylineEditPane',
                renderer: this.svgRenderer,
                interactive: true,
                bubblingMouseEvents: true
            });
            this.editablePolyline.addTo(this.map)
            this.addEditablePolylineAcnhorPoints()
            if (coordinates.length > 1) {
                const bounds = this.editablePolyline.getBounds();
                this.map.fitBounds(bounds, {
                    padding: [20, 20],
                    maxZoom: 16
                });
            }

        },

        addEditablePolylineAcnhorPoints() {
            this.removeAnchorPoints()
            this.anchorPointsGroup = L.layerGroup();
            this.anchorPointsGroup.addTo(this.map);
            let icon = L.divIcon({
                className: 'user-marker',
                html: this.markerStore.getDragAnchorMarkerIcon(),
            });
            let headIcon = L.divIcon({
                className: 'user-marker',
                html: this.markerStore.getDragAnchorHeadMarkerIcon(),
            });
            let polylinesLength = this.editablePolyline.getLatLngs().length

            this.editablePolyline.getLatLngs().forEach((latLng, i) => {
                let marker = L.marker([latLng.lat, latLng.lng], {icon: i + 1 === polylinesLength ? headIcon : icon, draggable: true});
                // Ensure that the marker can receive drag events
                marker.draggable = true
                marker.polylineData = {polyline: -99, point: i};
                this.anchorPointsGroup.addLayer(marker);
                marker.on('drag', function (ev) {
                    let position = ev.latlng;
                    let polylinePoints = this.editablePolyline.getLatLngs();
                    polylinePoints[ev.target.polylineData.point] = position;
                    this.editablePolyline.setLatLngs(polylinePoints);
                }.bind(this))
            })
        },

        removeLastPointFromEditablePolyline() {
            // Update line
            if (this.editablePolyline) {
                const latlngs = this.editablePolyline.getLatLngs()
                if (latlngs.length > 1) {
                    // Remove the last vertex
                    latlngs.pop()
                    // Write the updated vertices back to the polyline
                    this.editablePolyline.setLatLngs(latlngs)
                    // Update anchor points
                    this.addEditablePolylineAcnhorPoints()
                }
            }
        },

        addPointToEditablePolyline(coord) {
            // Update line
            if (!this.editablePolyline) {
                this.addEditablePolyline([[coord.lng, coord.lat]])
            }
            this.editablePolyline?.addLatLng(L.latLng(coord.lat, coord.lng))
            // Update anchor points
            this.addEditablePolylineAcnhorPoints()
        },

        getEditablePolylineCoordinates() {
            return this.editablePolyline ? this.editablePolyline.getLatLngs().map(c => [c.lng, c.lat]) : null
        },

        stopEditingPolyline() {
            this.removeAnchorPoints()
            if (this.editablePolyline) {
                this.editablePolyline.remove(this.map)
                this.editablePolyline = null
            }
        },

        /**
         * Adds a point to a polyline. The added point will be the last point.
         * @param type of the polyline
         * @param id is a unique identifier for the polyline, e.g. database id
         * @param lat latitude coordinate
         * @param lng longitude coordinate
         **/
        addPointToPolyLine: function (type, id, lat, lng) {
            this.polylines[type][id].addLatLng(L.latLng(lat, lng))
        },

        /**
         * Removes the last point from a polygon.
         * @param id is a unique identifier for the polygon, e.g. database id
         * @param type integer that refers to the group of polygons, used e.g. in toggling visibility
         **/
        removeLastPointFromPolygon: function (id, type = this.AREA) {
            let polygonPoints = this.polygons[type][id].getLatLngs()[0];
            polygonPoints.pop();
            this.polygons[type][id].setLatLngs(polygonPoints);
        },

        /**
         * Removes the last point from a polyline.
         * @param id is a unique identifier for the polyline, e.g. database id
         * @param type
         **/
        removeLastAddedPointFromPolygon: function (id, type) {
            this.removeLastPointFromPolygon(id, type)
        },

        /**
         * Removes the last point from a polyline.
         * @param type
         * @param id is a unique identifier for the polyline, e.g. database id
         **/
        removeLastPointFromPolyline: function (type, id) {
            let polylinePoints = this.polylines[type][id].getLatLngs();
            polylinePoints.pop();
            this.polylines[type][id].setLatLngs(polylinePoints);
        },

        /**
         * Adds a complete polygon to the map
         * @param id is a unique identifier for the polygon, e.g. database id
         * @param type
         * @param points are the coordinates in format { lng, lat } for each point
         * @param stroke
         * @param fill
         * @param transparency
         **/
        drawPolygon: function (id, points, type = this.AREA, stroke = '#1c455b', fill='#219ade', transparency=0.3, strokeWidth = 2) {
            let areas = []
            if (!Array.isArray(points[0][0])) {
                // Only one ring
                let ring = []
                points.forEach(point => {
                    ring.push([point[1], point[0]]);
                })
                areas.push(ring)
            } else {
                // Inner rings too
                points.forEach(ring => {
                    let ringPoints = []
                    ring.forEach(point => {
                        ringPoints.push([point[1], point[0]]);
                    })
                    areas.push(ringPoints);
                })
            }
            let polygon = L.polygon(areas, {
                color: stroke,
                fillColor: fill,
                fillOpacity: 1-transparency,
                weight: strokeWidth
            });
            polygon.type = type
            polygon.id = id
            polygon.addTo(this.map);
            if(!this.polygons[type]) {
                this.polygons[type] = []
            }
            this.polygons[type][id] = polygon;
        },

        /**
         * Store area lines temporarily
         * @param polygonIndex is a unique identifier for the polygon
         * @param type integer that refers to the group of polygons, used e.g. in toggling visibility
         **/
        storeAreaInfo: function (polygonIndex, type = this.AREA) {
            if(!this.polygonLines[type] || !this.polygonLines[type][polygonIndex]){
                // Populate lines from polygon
                this.polygonLines[type] = []
                if (this.polygons[type][polygonIndex]) {
                    let lines = []
                    let polygon = this.polygons[type][polygonIndex]
                    if (polygon) {
                        let rings = polygon.getLatLngs()
                        rings.forEach(ring => {
                            ring.forEach(latLng => lines.push([latLng.lng, latLng.lat]))
                        })
                    }
                    this.polygonLines[type][polygonIndex] = lines
                }
            }
            return this.polygonLines[type][polygonIndex]
        },

        /**
         * Store polyline temporarily
         * @param type integer that refers to the group of polygons, used e.g. in toggling visibility
         * @param polylineIndex is a unique identifier for the polygon
         **/
        storeLineInfo: function (type, polylineIndex) {
            let linestring = []
            if(!this.polylines[type]){
                this.polylines[type] = []
            }
            let line = this.polylines[type][polylineIndex]
            if (line) {
                // Return coordinates as {x, y} objects
                line.getLatLngs().forEach(function (latlng) {
                    linestring.push({
                        x: latlng.lng,  // longitude as x
                        y: latlng.lat   // latitude as y
                    })
                })
            }
            return linestring;
        },

        /**
         * Remove feature resize points
         **/
        removeAnchorPoints: function () {
            if (this.anchorPointsGroup !== null) {
                this.anchorPointsGroup.remove();
            }
        },

        /**
         * Add area resize points
         * @param polygonId is a unique identifier for the polygon
         * @param type integer that refers to the group of polygons, used e.g. in toggling visibility
         **/
        addAnchorPoints: function (polygonId, type = this.AREA) {
            this.removeAnchorPoints()
            // Create a group that can hold map objects
            this.anchorPointsGroup = L.layerGroup();
            // Add the group to the map object
            this.anchorPointsGroup.addTo(this.map);

            this.polygons[type][polygonId].getLatLngs().forEach(((value, index) => {
                value.forEach((latLng, i) => {
                    let marker = L.circleMarker([latLng.lat, latLng.lng], {
                        color: 'red',
                        fillColor: 'white',
                        fillOpacity: 0.8,
                        weight: 3,
                        radius: 6,
                        draggable: true
                    });
                    // Ensure that the marker can receive drag events
                    marker.polygonData = {polygon: polygonId, point: i, layer: index};
                    this.anchorPointsGroup.addLayer(marker);

                    marker.on('drag', function () {
                        this.movePoint(marker.polygonData, marker.getLatLng(), type)
                    }.bind(this))
                });
            }))

        },

        /**
         * Add polyline resize points
         * @param type
         * @param polylineId is a unique identifier for the polyline
         **/
        addPolylineAnchorPoints: function (type, polylineId) {
            if (this.anchorPointsGroup !== null) {
                this.anchorPointsGroup.remove();
            }
            // Create a group that can hold map objects
            this.anchorPointsGroup = L.layerGroup();
            // Add the group to the map object
            this.anchorPointsGroup.addTo(this.map);
            let icon = L.divIcon({
                className: 'user-marker',
                html: this.markerStore.getDragAnchorMarkerIcon(),
            });
            let headIcon = L.divIcon({
                className: 'user-marker',
                html: this.markerStore.getDragAnchorHeadMarkerIcon(),
            });
            let polylinesLength = this.polylines[type][polylineId].getLatLngs().length
            this.polylines[type][polylineId].getLatLngs().forEach((latLng, i) => {
                let marker = L.marker([latLng.lat, latLng.lng], {icon: i + 1 === polylinesLength ? headIcon : icon, draggable: true});
                // Ensure that the marker can receive drag events
                marker.draggable = true
                marker.polylineData = {polyline: polylineId, point: i};
                this.anchorPointsGroup.addLayer(marker);
                marker.on('drag', function (ev) {
                    let position = ev.latlng;
                    this.movePolylinePoint(type, ev.target.polylineData, position);
                }.bind(this))
            })
        },

        /**
         * Emits a tap event with the id of the tapped area
         * @param ev, clicked area
         **/
        areaTapEvent: function (ev) {
            const type = ev.target.type
            const id = ev.target.id
            if (!this.isEditing) {
                let polygonId = -1
                if (this.polygons[type] && this.polygons[type][id]) {
                    const polygon = this.polygons[type][id]
                    if (polygon) {
                        /** TODO - highlighting edges fail on second click
                         this.polygons.forEach(type => {
                            type.forEach((polygonItem, id) => {
                                if (polygonItem) {
                                    if (id === polygon.id) {
                                        console.log("Set wide " + id)
                                        polygonItem.setStyle({
                                            weight: 8,
                                        })
                                    } else {
                                        console.log("Set narrow " + id)
                                        polygonItem.setStyle({
                                            weight: 1
                                        })
                                    }
                                }
                            })
                        })
                          **/
                        var clickPoint = ev.latlng;
                        this.$emit('editAreaEvent', polygon.id, clickPoint)
                    }
                }
            }
        },

        unselectArea() {
            this.polygons.forEach(type => {
                type.forEach((polygon) => {
                    if (polygon) {
                        polygon.setStyle({
                            weight: 2,
                        })
                    }
                })
            })
        },


        /**
         * Store original area lines and set anchor points
         * * @param type integer that refers to the group of polygons, used e.g. in toggling visibility
         * @param polygonId is a unique identifier for the polygon
         **/
        editArea: function (polygonId, type = this.AREA) {
            if (!this.isEditing) {
                this.editablePolygonLineStrings = this.storeAreaInfo(polygonId, type)
                this.addAnchorPoints(polygonId, type)
            }
        },

        /**
         * Store original lines and set anchor points
         * @param type geometry category
         * @param polylineId is a unique identifier for the polyline
         **/
        editPolyline: function (type, polylineId) {
            if (!this.isEditing) {
                this.editablePolylineStrings = this.storeLineInfo(type, polylineId)
                this.addPolylineAnchorPoints(type, polylineId)
            }
        },

        /**
         * Move area points
         * @param polygonData
         * @param position, point position
         * @param type integer that refers to the group of polygons, used e.g. in toggling visibility
         **/
        movePoint: function (polygonData, position, type = this.AREA) {
            this.polygons[type][polygonData.polygon].getLatLngs()[polygonData.layer][polygonData.point] = position;
            this.polygons[type][polygonData.polygon].setLatLngs(this.polygons[type][polygonData.polygon].getLatLngs());
        },

        /**
         * Move polyline points
         * @param type
         * @param polylineData
         * @param position, point position
         **/
        movePolylinePoint: function (type, polylineData, position) {
            let polylinePoints = this.polylines[type][polylineData.polyline].getLatLngs();
            polylinePoints[polylineData.point] = position;
            this.polylines[type][polylineData.polyline].setLatLngs(polylinePoints);
        },

        /**
         *  Disable area editing
         * @param polygonId is a unique identifier for the polygon
         * @param type integer that refers to the group of polygons, used e.g. in toggling visibility
         **/
        disableAreaEditing: function (polygonId, type = this.AREA) {
            if (this.anchorPointsGroup !== null) {
                this.anchorPointsGroup.remove();
                this.anchorPointsGroup = null
            }
            this.removePolygon(polygonId, type)
            if (this.editablePolygonLineStrings) {
                this.drawPolygon(polygonId, this.editablePolygonLineStrings, type)
                this.editablePolygonLineStrings = null;
            }
        },

        /**
         *  Disable area editing
         * @param polylineId is a unique identifier for the polygon
         * @param type integer that refers to the group of polygons, used e.g. in toggling visibility
         **/
        disableLineEditing: function (polylineId, type = this.OTHER) {
            if (this.anchorPointsGroup !== null) {
                this.anchorPointsGroup.remove();
                this.anchorPointsGroup = null
            }
            this.removePolyline(polylineId, type)
            if (this.editablePolylineStrings) {
                this.drawPolyLine(polylineId, type, this.editablePolylineStrings)
                this.editablePolygonLineStrings = null;
            }
        },

        /**
         * Removes a polygon by id
         * @param id of the polygon to be removed
         * @param type number used for grouping polygons, e.g. in toggling visibility
         */
        removePolygon: function (id, type = this.AREA) {
            if (this.polygons[type] !== undefined) {
                if (this.polygons[type][id] !== undefined) {
                    // Remove polygon if exists
                    this.polygons[type][id].remove()
                    this.polygons[type][id] = undefined
                    // Remove line if exists
                    if(this.polygonLines[type] && this.polygonLines[type][id]) {
                        this.polygonLines[type][id] = undefined
                    }
                    // Remove label if exists
                    if (this.polygonLabels[type] && this.polygonLabels[type][id]) {
                        this.polygonLabels[type][id].remove();
                        this.polygonLabels[type][id] = undefined;
                    }
                }
            }
        },

        /**
         * Adds an info bubble with text for a polygon
         * @param id of the polygon
         * @param label is the text to be shown in the info bubble
         * @param lat coordinate of the bubble anchor
         * @param lng coordinate of the bubble anchor
         * @param type number used for grouping polygons, e.g. in toggling visibility
         */
        addMarkerLabel: function (id, label, lat, lng, type) {
            if (!this.polylineBubbles[type] || !this.polylineBubbles[type][id] || !this.polylineBubbles[type][id].isOpen()) {
                if (!this.polylineBubbles[type]) {
                    this.polylineBubbles[type] = []
                }
                this.polylineBubbles[type][id] = null
                let popup = L.popup({'className': 'popupCustom'})
                    .setLatLng(L.latLng(lat, lng))
                    .setContent('<span class="leaflet-bubble-text">' + label + '</span>')
                this.map.addLayer(popup);
                this.polylineBubbles[type][id] = popup
            }
        },

        /**
         * Adds an info bubble with text for a polygon
         * @param id of the polygon
         * @param label is the text to be shown in the info bubble
         * @param lat coordinate of the bubble anchor
         * @param lng coordinate of the bubble anchor
         * @param type number used for grouping polygons, e.g. in toggling visibility
         */
        addIconsLabel: function (id, icons, lat, lng, type) {
            if (!this.polylineBubbles[type] || !this.polylineBubbles[type][id] || !this.polylineBubbles[type][id].isOpen()) {
                if (!this.polylineBubbles[type]) {
                    this.polylineBubbles[type] = []
                }
                this.polylineBubbles[type][id] = null
                // Parse icons to bubble
                let content = "<div>"
                icons.forEach(icon =>
                    content += '<img src="'+icon+'" alt="icon" style="height: 2em; width: 2em; padding-left: .5em" />')
                content += "</div>"
                // Show popup
                let popup = L.popup({'className': 'popupCustom'})
                    .setLatLng(L.latLng(lat, lng))
                    .setContent(content)
                this.map.addLayer(popup);
                this.polylineBubbles[type][id] = popup
            }
        },



        hideMarkerLabel: function(id, type) {
            this.hidePolylineBubble(id, type)
        },



        /**
         * Adds an info bubble with text for a vehicle
         * @param id of the polygon
         * @param label is the text to be shown in the info bubble
         * @param lat coordinate of the bubble anchor
         * @param lng coordinate of the bubble anchor
         */
        addVehicleLabel: function (id, label, lat, lng) {
            if (!this.vehicleInfos) {
                this.vehicleInfos = []
            }
            this.hideVehicleLabelIfExists(id)
            let popup = L.popup({'className': 'customPopup', closeButton: false, autoClose: false, closeOnClick: false})
                .setLatLng(L.latLng(lat, lng))
                .setContent('<span class="leaflet-bubble-text">' + label + '</span>')
            this.map.addLayer(popup);
            this.vehicleInfos[id] = popup
        },

        hideVehicleLabelIfExists: function (id) {
            if (this.vehicleInfos) {
                let marker = this.vehicleInfos[id]
                if (marker !== undefined) {
                    this.map.removeLayer(this.vehicleInfos[id])
                    this.vehicleInfos[id] = undefined
                }
            }
        },



        /**
         * Hides an info bubble with text
         * @param id of the polygon
         * @param label is the text to be shown in the info bubble
         * @param lat coordinate of the bubble anchor
         * @param lng coordinate of the bubble anchor
         * @param type integer that refers to the group of polygons, used e.g. in toggling visibility
         */
        addAreaLabel: function (id, label, lat, lng, type = this.AREA) {
            let popup = L.popup({closeButton: true, className: 'popupCustom', autoPan: false, closeOnClick: false});
            popup.setLatLng(L.latLng(lat, lng));
            popup.setContent('<span class="leaflet-bubble-text">' + label + "</span>");
            this.map.addLayer(popup);
            if(!this.polygonLabels[type]) this.polygonLabels[type] = []
            this.polygonLabels[type][id] = popup
        },

        hideAreaLabels(type = this.AREA) {
            if (this.polygonLabels[type]) {
                let labels = this.polygonLabels[type]
                labels.forEach(label => label.remove())
            }
        },

        showInfoBubbleWithoutItem(title, content, lat, lng) {
            let contentCode = '<span class="leaflet-bubble-title">' + title + '</span>'
            if (content) {
                if (content instanceof Object) {
                    contentCode += '<table>'
                    for (var key in content) {
                        contentCode += '<tr><td class="leaflet-bubble-sub-title">' + key + '</td></tr><tr><td class="leaflet-bubble-text">' + content[key] + '</td></tr>'
                    }
                    contentCode += '</table>'
                } else {
                    contentCode += '<span class="leaflet-bubble-text">' + content + '</span>'
                }
            }
            let popup = L.popup({
                closeButton: true,
                autoPan: false,
                closeOnClick: false
            });
            popup.setLatLng(L.latLng(lat, lng));
            popup.setContent(contentCode);
            this.map.addLayer(popup);
        },

        showInfoBubbleWithAction(id, title, content, lat, lng, actionTitle, action, editAction) {
            let contentCode = '<span class="leaflet-bubble-title">' + title + '</span>'
            if (content) {
                if (content instanceof Object) {
                    contentCode += '<table>'
                    for (var key in content) {
                        contentCode += '<tr><td class="leaflet-bubble-sub-title">' + key + '</td></tr><tr><td class="leaflet-bubble-text">' + content[key] + '</td></tr>'
                    }
                    contentCode += '</table>'
                } else {
                    contentCode += '<span class="leaflet-bubble-text">' + content + '</span>'
                }
            }
            // Buttons
            contentCode += '<div class="text-right">'

            // Edit action
            if (editAction) {
                contentCode += '<div class="text-right"><button class="bubble-edit-button" id="popup-edit-btn-'+id+'">'+this.$t('common.edit')+'</button>'
            }

            // Action
            if (actionTitle && action) {
                contentCode += '<button class="bubble-button" id="popup-btn-'+id+'">'+actionTitle+'</button>'
            }

            let popup = L.popup({
                closeButton: true,
                autoPan: false,
                closeOnClick: false
            });
            contentCode += '</div>'

            popup.setLatLng(L.latLng(lat, lng));
            popup.setContent(contentCode);

            // Button events
            if (editAction || action){
                // Attach event listener properly when popup opens
                popup.onAdd = function (map) {
                    L.Popup.prototype.onAdd.call(this, map);
                    setTimeout(() => {
                        if (action) {
                            const button = this._contentNode.querySelector("#popup-btn-"+id);
                            if (button) {
                                button.addEventListener("click", () => {
                                    popup.remove()
                                    action(id)
                                });
                            }
                        }
                        if (editAction) {
                            const button = this._contentNode.querySelector("#popup-edit-btn-"+id);
                            if (button) {
                                button.addEventListener("click", () =>  {
                                    popup.remove()
                                    editAction(id)
                                });
                            }
                        }
                    }, 0);
                };
            }
            // Finally, open popup
            popup.openOn(this.map)
            // Close event - remove highlighting of area
            popup.on('remove', () => {
                this.unselectArea()
            });
        },

        showInfoBubble: function (type, id, title, content, lat, lng) {
            const marker = this.markersById?.[type]?.[id]
            if (marker) {
                this.showInfoBubbleWithoutItem(title, content, lat, lng)
            }
        },

        hideInfoBubbles() {
            this.map.eachLayer((layer) => {
                if (layer instanceof L.Popup) {
                    layer.remove();
                }
            });
        },

        /**
         * Returns the coordinates of a polygon
         * @param id
         * @param type integer that refers to the group of polygons, used e.g. in toggling visibility
         **/
        getPolygonBoundaries: function (id, type = this.AREA) {
            return this.polygons[type][id].getLatLngs()
        },
        /**
            * Emits a tap event with the id of the tapped marker
            * @param id of the marker that was tapped
        **/
        markerTapEvent: function (e) {
            this.contextMenuVisible = false
            this.$emit('onMarkerTap', e.target.markerData)
        },

        /**
         * Emits a tap event and determine which map objects were tapped
         **/
        generalTapEvent: async function (e) {
            this.contextMenuVisible = false
            let lineSource = e.sourceTarget ? e.sourceTarget.lineData : null
            const zoom = this.getMapZoomLevel()
            const threshold = zoom > 17 ? 1 : zoom > 15 ? 10 : 15
            var clickPoint = e.latlng; // Get the coordinates where the click occurred
            // Array to store markers found at the clicked point
            const markers = [];
            // Iterate over each layer on the map
            this.map.eachLayer(function(layer) {
                if (layer instanceof L.CircleMarker && clickPoint.distanceTo(layer.getLatLng()) <= threshold ) {
                    markers.push(layer); // Add the marker to the array
                }

                // Check if the layer is a marker and if its coordinates are close to the clicked point
                if (layer instanceof L.Marker && clickPoint.distanceTo(layer.getLatLng()) <= threshold ) {
                    markers.push(layer); // Add the marker to the array
                }
                if (layer instanceof L.Polyline) {
                    layer.geomType = "Polyline"



                    // Check if event was triggered by this line click
                    if (lineSource && layer.lineData && String(lineSource.id) === String(layer.lineData.id) && Number(lineSource.type) === Number(layer.lineData.type)) {
                        markers.push(layer); // Add the layer to the array
                    } else {
                        // Check if there are lines near by
                        const layerPositions = layer.getLatLngs();
                        // Iterate over each point in the polyline
                        for (let i = 0; i < layerPositions.length; i++) {
                            const position = layerPositions[i]
                            if (position instanceof Array) {
                                // TODO - This must be improved for line observations having long distances between points - in this case a click might not be registered
                                let nearBy = position.find(coord => clickPoint.distanceTo(coord) <= threshold)
                                if (nearBy) {
                                    markers.push(layer); // Add the layer to the array
                                }
                            } else {
                                // Calculate the distance from the click point to the polyline point
                                const distance = clickPoint.distanceTo(position);
                                // If the distance is within the threshold and the polyline layer has not been found yet, consider it as a clicked layer
                                if (distance <= threshold) {
                                    markers.push(layer); // Add the layer to the array
                                    break;
                                }
                            }
                        }
                    }
                }
            });
            if (markers.length <= 1) {
                // Emit event for single marker tap
                if(markers[0] instanceof L.Marker) {
                    this.$emit('onMarkerTap', markers[0].markerData);
                } else if(markers[0] instanceof L.Polyline || markers[0].geomType === 'Polyline') {
                    this.$emit('onPolylineTap', markers[0].lineData, clickPoint);
                }
            } else {
                const markerData = []
                markers.forEach(marker => {
                    if(marker instanceof L.Marker && marker.markerData) {
                        markerData.push(marker.markerData)
                    } else if((marker instanceof L.Polyline || marker.geomType === 'Polyline') && (!this.ignoreTraceTap ||
                        (marker.lineData && marker.lineData.type !== this.WORK_TRACE && marker.lineData.type !== this.TRACE))
                    ) {
                        markerData.push(marker.lineData)
                    }
                })

                // Remove duplicate entries from markerData (i.e. same item has marker and line)
                const seen = new Set();
                const uniqueMarkers = markerData.filter(item => {
                    const key = `${item.id}|${item.type}`;
                    if (seen.has(key)) return false;
                    seen.add(key);
                    return true;
                });
                if (uniqueMarkers.length === 1) {
                    const marker = uniqueMarkers[0]
                    if (this.isLineType(marker.type)) {
                        this.$emit('onPolylineTap', marker, clickPoint); // Emit event for single line tap
                    } else {
                        this.$emit('onMarkerTap', uniqueMarkers[0]); // Emit event for single marker tap
                    }
                } else if (uniqueMarkers.length > 1) {
                    this.$emit('onMultiMarkerTap', uniqueMarkers); // Emit event for multiple marker tap
                }
            }
        },

        isLineType(type) {
            switch (type) {
            case this.SKI_TRACK:
            case this.CABLE:
                return true
            }
            return false
        },

        /**
         * Emits a tap event with the id of the tapped marker
         * @param id of the marker that was tapped
         **/
        markerPointerEnterEvent: function (e) {
            this.$emit('onMarkerPointerEnter', e.target.markerData)
        },

        /**
         * Shows a map marker on the map (or updates if exists)
         * @param id of the marker
         * @param type of the marker (VEHICLE, OBSERVATION, EQUIPMENT, ...)
         * @param lat coordinate for the marker
         * @param lng coordinate for the marker
         * @param iconElement as HTML or SVG code
         * @param draggable boolean
         * @param zIndex
         */
        showMapMarker: function (
            id,
            type,
            lat,
            lng,
            iconElement,
            draggable = false,
            zIndex = 5,
            backgroundShadow = false,
            externalId = null
        ) {
            if (!this.map) return

            this.hideMarkerIfExists(id, type)

            if (!this.markerLayers[type]) {
                this.markerLayers[type] = markRaw(L.featureGroup().addTo(this.map))
            }

            if (!this.markersById) {
                this.markersById = {}
            }
            if (!this.markersById[type]) {
                this.markersById[type] = {}
            }

            let marker

            if (!iconElement) {
                const circleOptions = {
                    radius: 5,
                    color: '#000000',
                    weight: 2,
                    fill: true,
                    fillColor: '#1a6fb9',
                    fillOpacity: 0.8,
                    opacity: 1,
                    interactive: true,
                    pane: 'markerPane'
                }

                marker = L.circleMarker([lat, lng], circleOptions)

                marker.on({
                    mouseover: (e) => {
                        e.target.setStyle({ radius: 7, weight: 3 })
                        e.target._map.getContainer().style.cursor = 'pointer'
                    },
                    mouseout: (e) => {
                        e.target.setStyle({ radius: 5, weight: 2 })
                        e.target._map.getContainer().style.cursor = ''
                    },
                    click: (e) => {
                        this.markerTapEvent(e)
                    }
                })
            } else {
                let icon

                if (!backgroundShadow) {
                    icon = L.divIcon({
                        html: iconElement,
                        shadowSize: [0, 0],
                        className: 'dummy',
                        iconAnchor: [6, 6]
                    })
                } else {
                    icon = L.divIcon({
                        html: iconElement,
                        className: 'user-marker',
                        iconAnchor: [0, 0]
                    })
                }

                marker = L.marker([lat, lng], {
                    zIndexOffset: zIndex,
                    icon: icon,
                    draggable: draggable,
                    autoPan: draggable
                })
            }

            marker.markerData = externalId
                ? { id: externalId, type: type }
                : { id: id, type: type }

            marker.addEventListener('click', this.generalTapEvent)
            marker.addEventListener('mouseover', this.markerPointerEnterEvent)

            if (draggable) {
                marker.addEventListener('dragend', function (e) {
                    this.dragging = false
                    this.$emit('onDragEnd', {
                        id: id,
                        latlng: e.target._latlng,
                        position: {
                            x: e.target._latlng.lng,
                            y: e.target._latlng.lat
                        }
                    })
                }.bind(this))
            }

            this.markerLayers[type].addLayer(marker)
            this.markersById[type][id] = marker
        },

        hideMarkerIfExists: function (id, type) {
            const layer = this.markerLayers?.[type]
            const marker = this.markersById?.[type]?.[id]
            if (layer && marker) {
                layer.removeLayer(marker)
                delete this.markersById[type][id]
            }
        },

        removeEquipmentGroup: function () {
            if (this.equipmentGroup) this.equipmentGroup.remove();
        },

        removeMapMarker: function (id, type) {
            const layer = this.markerLayers?.[type]
            const marker = this.markersById?.[type]?.[id]

            if (layer && marker) {
                layer.removeLayer(marker)
                delete this.markersById[type][id]
            }
        },

        removeMapMarkerByType: function (type) {
            const layer = this.markerLayers?.[type]

            if (type && layer) {
                this.clearClusterByType(type)
                layer.clearLayers()

                if (this.markersById?.[type]) {
                    this.markersById[type] = {}
                }
            }
        },

        clearClusterByType(type) {
            switch (type) {
            case this.OBSERVATION:
                this.observationGroup.clearLayers();
                break;
            case this.MATERIAL_STORAGE:
                this.storageGroup.clearLayers();
                break;
            case this.MATERIAL_STATION:
                this.stationGroup.clearLayers();
                break;
            case this.WORK_ASSIGNMENT:
                this.workAssignmentGroup.clearLayers();
                break;
            case this.STREET_LIGHT:
                this.streetLightsGroup.clearLayers();
                break;
            case this.POWER_CENTER:
                this.powerStationsGroup.clearLayers();
                break;
            case this.TRAFFIC_SIGN:
                this.trafficSignGroup.clearLayers();
                break;
            case this.MIXED_WASTE_BINS:
                this.mixedWasteBinGroup.clearLayers();
                break;
            case this.DRAINS:
                this.stormDrainGroup.clearLayers();
                break;
            default:
                break;
            }
        },

        getPolylineLength(type, id){
            return this.polylines[type][id].getLatLngs().length
        },

        getPolygonLength(id, type = this.AREA){
            return this.polygons[type][id].getLatLngs()[0].length
        },

        attachEventListenersToAreas: function () {
            this.polygons.forEach(type =>{
                type.forEach(polygon => {
                    if (polygon) {
                        polygon.on('click', this.areaTapEvent)
                    }
                })
            })
        },

        removeAreaEventListeners: function () {
            this.polygons.forEach(type =>{
                type.forEach(polygon => {
                    if (polygon) {
                        polygon.removeEventListener('tap', this.areaTapEvent)
                    }
                })
            })
        },

        zoomToPolygon: function(points) {
            let areas = []
            if (!Array.isArray(points[0][0])) {
                // Only one ring
                let ring = []
                points.forEach(point => {
                    ring.push([point[1], point[0]]);
                })
                areas.push(ring)
            } else {
                // Inner rings too
                points.forEach(ring => {
                    let ringPoints = []
                    ring.forEach(point => {
                        ringPoints.push([point[1], point[0]]);
                    })
                    areas.push(ringPoints);
                })
            }
            const poly = L.polygon(areas);
            const bounds = poly.getBounds();
            this.map.fitBounds(bounds, { padding: [40, 40] }); // optional padding
        },

        /**
         * Show video route
         * @param color, route color
         * @param routeId, video metadata id
         * @param route, route coordinate points
         */
        drawObservationVideoRoute: function (color, routeId, route) {
            if (route.length > 1) {
                let line = route.map((point) => {
                    return [point.lat, point.lon]
                });
                let polyline = L.polyline(line, {
                    color: color,
                    weight: 5
                });
                polyline.lineData = routeId
                polyline.addTo(this.map)
                L.polylineDecorator(polyline, {
                    patterns: [
                        {
                            repeat: 50,
                            symbol: L.Symbol.arrowHead({
                                pixelSize: 5,
                                polygon: false,
                                headAngle: 75,
                                pathOptions: {
                                    stroke: true,
                                    weight: 2,
                                    color: '#FFFFFF'
                                }
                            })
                        }
                    ]
                }).addTo(this.map)
                if (!this.polylines[this.TRACE]) {
                    this.polylines[this.TRACE] = []
                }
                this.polylines[this.TRACE][routeId] = polyline
            }
        },

        drawSimulatedRoute: function (routeId, route) {
            if (route.length > 1) {
                let line = route.map((point) => {
                    return [point.y, point.x]
                });
                let polyline = L.polyline(line, {
                    color: 'grey',
                    weight: 5,
                    pane: 'polylinePane',
                    opacity: 0.4
                });
                polyline.lineData = routeId
                polyline.addTo(this.map);
                polyline.bringToFront()
                let decorator = L.polylineDecorator(polyline, {
                    patterns: [
                        {
                            repeat: 50,
                            symbol: L.Symbol.arrowHead({
                                pixelSize: 5,
                                polygon: false,
                                headAngle: 75,
                                pathOptions: {
                                    stroke: true,
                                    weight: 2,
                                    pane: 'polylinePane',
                                    color: '#000000'
                                }
                            })
                        }
                    ]
                })
                decorator.addTo(this.map)
                decorator.bringToFront()
                if (!this.polylines[this.TRACE]) {
                    this.polylines[this.TRACE] = []
                }
                if (!this.polylineDecorators[this.TRACE]) {
                    this.polylineDecorators[this.TRACE] = []
                }
                this.polylines[this.TRACE][routeId] = polyline
                this.polylineDecorators[this.TRACE][routeId] = decorator
            }
        },

        hideSimulatedRoute: function (routeId) {
            if (this.polylines[this.TRACE] && this.polylines[this.TRACE][routeId])   {
                this.polylines[this.TRACE][routeId].remove(this.map)
            }
            if (this.polylineDecorators[this.TRACE] && this.polylineDecorators[this.TRACE][routeId])   {
                this.polylineDecorators[this.TRACE][routeId].remove(this.map)
            }
            // Clear route progress line
            if (this.videoRoutes !== undefined) {
                this.videoRoutes.forEach(route => {
                    if (route) {
                        route.remove(this.map)
                    }
                })
                this.videoRoutes = []
            }
        },

        /**
         * Removes route progress lines from map
         * @param routeId
         */
        removeRouteProgressPolyLine: function (routeId) {
            if (this.videoRoutes[routeId] !== undefined) {
                this.videoRoutes[routeId].remove(this.map)
                this.videoRoutes[routeId] = undefined
            }
        },

        /**
         * Show route progress
         * @param pointIndex, current video time coordinate
         * @param routeId, video metadata id
         * @param videoEnded, Fill rest of the route if coordinates goes over the video
         */
        drawRouteProgressPolyLine: function (pointIndex, routeId, videoEnded = false, color = '#7CFC00') {
            // Clear old route progress line
            if (this.videoRoutes[routeId] !== undefined) {
                this.videoRoutes[routeId].remove(this.map)
                this.videoRoutes[routeId] = undefined
            }

            let line = []
            let point = 0
            if (this.polylines[this.TRACE] && this.polylines[this.TRACE][routeId]) {
                if (videoEnded) {
                    this.polylines[this.TRACE][routeId].getLatLngs().forEach(function (value, index) {
                        point = index
                        line.push(value)
                    })
                } else {
                    this.polylines[this.TRACE][routeId].getLatLngs().forEach(function (value, index) {
                        if (index <= pointIndex) {
                            point = index
                            line.push(value)
                        }
                    })
                }
                // Line string need at least two points
                if (point > 0) {
                    let polyline = L.polyline(line, {
                        color: color,
                        weight: 5,
                        pane: 'polylinePane',
                        opacity: 0.6
                    });
                    polyline.lineData = routeId
                    polyline.addTo(this.map);
                    polyline.bringToFront()
                    this.videoRoutes[routeId] = polyline
                }
            }
        },

        removeRouteProgressPolyLines: function (videos) {
            videos.forEach(videoId => {
                // Clear old route progress line
                if (this.videoRoutes[videoId] !== undefined) {
                    this.videoRoutes[videoId].remove(this.map)
                    this.videoRoutes[videoId] = undefined
                }
            })
        },

        hexToRgb: function (hex) {
            var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
            return result ? {
                r: parseInt(result[1], 16),
                g: parseInt(result[2], 16),
                b: parseInt(result[3], 16)
            } : null;
        },

        addGeoLabel(lat, lon, text, collectionKey) {
            if (!this.geoLabels[collectionKey] || !Array.isArray(this.geoLabels[collectionKey])) {
                this.geoLabels[collectionKey] = []
            }
            const icon = L.divIcon({
                html: '',
                className: 'geojson-no-icon',
                iconSize: [0,0],
                iconAnchor: [0,0]
            });
            let marker = new L.marker([lat, lon], {icon: icon})

            marker.bindTooltip(text, {
                permanent: true,
                direction: 'right',
                className: 'geojson-label',
                offset: [0, 0],
                sticky: true
            })
            marker.addTo(this.map)

            this.geoLabels[collectionKey].push(marker)
        },

        removeGeoLabels(collectionKey) {
            if (this.geoLabels[collectionKey] && Array.isArray(this.geoLabels[collectionKey]))
            {
                this.geoLabels[collectionKey].forEach(marker => marker.remove())
            }
            this.geoLabels[collectionKey] = []
        },

        removeSingleGeoLabel(collectionKey, text) {
            if (this.geoLabels[collectionKey][text]) {
                this.geoLabels[collectionKey][text].forEach(marker => marker.remove())
            }
            this.geoLabels[collectionKey][text] = []
        },

        removeLastGeoJsonObject() {
            if (this.importedObjects.getLayers() && this.importedObjects.getLayers().length > 0) {
                this.importedObjects.removeLayer(this.importedObjects.getLayers()[this.importedObjects.getLayers().length-1])
            }
        },

        removeGeoJsonObject(index) {
            if (this.importedObjects.getLayers() && this.importedObjects.getLayers().length > 0) {
                this.importedObjects.removeLayer(this.importedObjects.getLayers()[index])
            }
        },

        //  This is an alternative geojson drawing the works better for many goejson layers like order geometries
        async addGeoJsonLayer(geoJson, focusOnLayer = true, lineColor = '#B200FF', addLineEndIndicators = false,
            transparency = 1, lineWidth = 3, visible = true){
            const layer = this.getGeoJsonFeature(geoJson, lineColor, addLineEndIndicators,
                transparency, lineWidth)
            this.geoJsonLayers.push({
                visible: visible,
                layer: layer
            })
            if (visible) {
                this.map.addLayer(layer)
                if (layer && focusOnLayer) {
                    this.map.fitBounds(layer.getBounds(), { padding: [20, 20] })
                }
            }

        },

        toggleGeoJsonVisibility(index) {
            if (index >= 0 && index < this.geoJsonLayers.length) {
                let layerItem = this.geoJsonLayers[index]
                if (layerItem) {
                    if (layerItem.visible) {
                        // Just hide it
                        layerItem.visible = false
                        this.map.removeLayer(layerItem.layer)
                    } else {
                        layerItem.visible = true
                        this.redrawGeoJsonLayers()
                    }
                }
            }
        },

        setGeoJsonVisibility(index, visible, redraw = true) {
            if (index >= 0 && index < this.geoJsonLayers.length) {
                const layerItem = this.geoJsonLayers[index]
                if (!layerItem) {
                    return
                }
                if (visible && !layerItem.visible) {
                    layerItem.visible = true
                    if (redraw) {
                        this.redrawGeoJsonLayers()
                    }
                } else if (!visible && layerItem.visible) {
                    layerItem.visible = false
                    this.map.removeLayer(layerItem.layer)
                }
            }
        },

        swapGeoJsonLayers(indexA, indexB) {
            [this.geoJsonLayers[indexA], this.geoJsonLayers[indexB]] = [this.geoJsonLayers[indexB], this.geoJsonLayers[indexA]]
            this.redrawGeoJsonLayers()
        },

        updateGeoJsonLayer(index, geoJson, focusOnLayer = true, lineColor = '#B200FF', addLineEndIndicators = false,
            transparency = 1, lineWidth = 3, visible = true) {
            let layerItem = this.geoJsonLayers[index]
            this.map.removeLayer(layerItem.layer)
            const geoJsonFeature = this.getGeoJsonFeature(geoJson, lineColor, addLineEndIndicators,
                transparency, lineWidth)
            layerItem.visible = visible
            layerItem.layer = geoJsonFeature
            this.redrawGeoJsonLayers()
        },

        redrawGeoJsonLayers() {
            // Hide all layers
            this.geoJsonLayers.forEach(layerItem => {
                if (this.map.hasLayer(layerItem.layer)) {
                    this.map.removeLayer(layerItem.layer)
                }
            })
            // Now re-draw all
            this.geoJsonLayers.forEach(layerItem => {
                if (layerItem.visible) this.map.addLayer(layerItem.layer)
            })
        },

        removeGeoJsonLayer(index) {
            if (index >= 0 && index < this.geoJsonLayers.length) {
                const layerItem = this.geoJsonLayers[index]
                if (layerItem && this.map.hasLayer(layerItem.layer)) {
                    this.map.removeLayer(layerItem.layer)
                    this.geoJsonLayers.splice(index, 1)
                }
            }
        },

        removeGeoJsonLayers() {
            this.geoJsonLayers.forEach(layerItem => this.map.removeLayer(layerItem.layer))
            this.geoJsonLayers = []
        },

        addGeoJsonObjects: function (geoJson, focusOnLayer = true, lineColor = '#B200FF', addLineEndIndicators = false,
            transparency = 1, lineWidth = 3){
            const geoJsonFeature = this.getGeoJsonFeature(geoJson, lineColor, addLineEndIndicators,
                transparency, lineWidth)
            this.importedObjects.addLayer(geoJsonFeature)
            this.importedObjects.addTo(this.map);
            geoJsonFeature.bringToBack()
            if (geoJsonFeature && focusOnLayer) {
                this.map.fitBounds(geoJsonFeature.getBounds(), { padding: [20, 20] })
            }
        },

        getGeoJsonFeature(geoJson, lineColor, addLineEndIndicators, transparency, lineWidth) {
            this.addLineEndIndicators = addLineEndIndicators;
            if (!geoJson) return null;

            // --- Parse GeoJSON only once ---
            const parsed = typeof geoJson === 'string' ? JSON.parse(geoJson) : geoJson;
            const color = lineColor;
            const opacity = transparency ?? 1;
            const weight = lineWidth ?? 2;

            return L.geoJSON(parsed, {
                pane: 'geojsonPane',
                renderer: this.svgRenderer,
                interactive: true,
                bubblingMouseEvents: true,
                // --- Circles (points) ---
                pointToLayer: (feature, latlng) => {
                    const isSelected = feature.properties?.selected === true;
                    const fillColor = isSelected ? '#ff0000' : color;

                    const circle = L.circleMarker(latlng, {
                        radius: 5,
                        color: '#000000',
                        weight: 2,
                        fill: true,
                        fillColor,
                        fillOpacity: opacity,
                        opacity: 1,
                        interactive: true,
                    });

                    // hover + click for circles
                    circle.on({
                        mouseover: (e) => {
                            e.target.setStyle({ radius: 7, weight: 3 });
                            e.target._map.getContainer().style.cursor = 'pointer';
                        },
                        mouseout: (e) => {
                            e.target.setStyle({ radius: 5, weight: 2 });
                            e.target._map.getContainer().style.cursor = '';
                        },
                        click: (e) => {
                            this.$emit('onGeoJsonClicked', feature, circle, feature.properties.id, feature.properties.importedItemIndex)
                        },
                    });

                    return circle;
                },

                // --- Style for lines and polygons ---
                style: (feature) => {
                    const geomType = feature.geometry?.type;
                    if (geomType === 'Point' || geomType === 'MultiPoint') return {};

                    const isSelected = feature.properties?.selected === true;
                    return {
                        color: isSelected ? '#ff0000' : color,
                        weight,
                        opacity,
                        interactive: true,
                    };
                },

                // --- Line and polygon event handlers ---
                onEachFeature: (feature, layer) => {
                    const geomType = feature.geometry?.type;
                    if (geomType === 'Point' || geomType === 'MultiPoint') return;

                    const origWeight = layer.options.weight;
                    const color = feature.properties?.selected === true ? '#ff0000' : lineColor;

                    layer.on({
                        mouseover: (e) => {
                            e.target.setStyle({ weight: origWeight + 2 });
                            e.target._map.getContainer().style.cursor = 'pointer';
                            this.$emit('onGeoJsonHoverEvent', null, feature.properties, feature.properties.id, feature.properties.importedItemIndex)
                        },
                        mouseout: (e) => {
                            e.target.setStyle({ weight: origWeight });
                            e.target._map.getContainer().style.cursor = '';
                            this.$emit('onGeoJsonHoverExitEvent', null, feature.properties, feature.properties.id, feature.properties.importedItemIndex)                        },
                        click: (e) => {
                            this.$emit('onGeoJsonClicked', feature, layer, feature.properties.id, feature.properties.importedItemIndex)
                        },
                    });

                    // polyline indicator
                    if (addLineEndIndicators && geomType === 'LineString') {
                        this.addPolylineEndIndicators(feature, color);
                    }
                },
            });
        },


        zoomToGeoJsons() {
            let bounds = new L.LatLngBounds();
            this.map.eachLayer(layer => {
                if (layer.options && layer.options.pane === 'geojsonPane') {
                    if (layer.getBounds) {
                        bounds.extend(layer.getBounds()); // If the layer has a getBounds method (like Polygon, Polyline)
                    } else if (layer.getLatLng) {
                        bounds.extend(layer.getLatLng()); // If the layer is a single point (like Marker)
                    }
                }
            });
            if (bounds.isValid()) {
                this.map.fitBounds(bounds, { padding: [20, 20] }); // Zoom to the bounds of the LayerGroup
            }
        },


        hideGeoJsonObjects: function () {
            this.importedObjects.eachLayer(function(layer) {
                this.map.removeLayer(layer);
            }.bind(this));
            this.importedObjects = L.layerGroup();
        },

        getViewBoundsCoordinates() {
            const bounds = this.map.getBounds();
            const left = bounds.getSouthWest().lng;
            const bottom = bounds.getSouthWest().lat;
            const right = bounds.getNorthEast().lng;
            const top = bounds.getNorthEast().lat;
            return [left, bottom, right, top];
        },

        getPolylineGeometry(type, id) {
            let points = this.polylines[type][id] && this.polylines[type][id].getLatLngs()
            return points ? points.map(item => [item['lat'], item['lng']]) : null
        },

        getPointGeometry(id, type) {
            const marker = this.markersById?.[type]?.[id]
            const point = marker?.getLatLng()

            return point ? [point.lng, point.lat] : null
        },

        getPolygonGeometry(id, type = this.AREA) {
            return this.polygons[type][id].toGeoJSON().geometry.coordinates
        },

        getMapType() {
            return 'LEAFLET'
        },

        hideMapControls() {
            if (this.$refs.userposControl.style.display) {
                this.$refs.userposControl.style.display = 'none'
                this.$refs.sliderControl.style.display = 'none'
            }
            this.layerControlVisible = false
            this.zoomVisible = false
        }
    }
}
</script>

<style>
.cluster-observation {
    background-color: rgb(246, 200, 114);
    color: black;
}

.cluster-storage {
    background-color: rgb(131, 201, 240);
    color: #fafafa;
}

.cluster-station {
    background-color: rgb(148, 148, 148);
    color: #fafafa;
}

.cluster-workAssignment {
    background-color: rgb(76, 194, 140);
    color: #fafafa;
}

.cluster-streetLight {
    background-color: rgb(255, 255, 255);
    color: #ffc400;
}

.cluster-powerStation {
    background-color: rgb(35, 35, 35);
    color: #ffc400;
}

.cluster-trafficSign {
    background-color: rgb(189, 58, 28);
    color: #fafafa;
}
.cluster-mixedWasteBin {
    background-color: rgb(181, 109, 173);
}
.cluster-stormdrain {
    background-color: rgb(6, 170, 147);
    color: #fafafa;
}

.general-cluster {
    font-size: 1.3em;
    text-align: center;
    line-height: 2.5em;
    border: 0.1em solid black;
    box-shadow: 0 0 0.2em black;
    border-radius: 50%;
}

/* Vector text styles */

.peak-text {
    color: #404041;
    font-style: italic;
    font-size: 1em;
}

.water-text-small {
    color: #1964b2;
    font-style: italic;
    font-size: .9em;
    text-shadow:
        1px 1px 0 rgb(246, 245, 241),
        -1px -1px 0 rgb(246, 245, 241),
        1px -1px 0 rgb(246, 245, 241),
        -1px 1px 0 rgb(246, 245, 241);
}

.water-text-medium {
    color: #1964b2;
    font-style: italic;
    font-size: 1.1em;
    text-shadow:
        2px 2px 0 rgb(246, 245, 241),
        -2px -2px 0 rgb(246, 245, 241),
        2px -2px 0 rgb(246, 245, 241),
        -2px 2px 0 rgb(246, 245, 241);
}


.river-text-small {
    color: #033c77;
    font-style: italic;
    font-size: .9em;
    text-shadow:
        1px 1px 0 rgb(246, 245, 241),
        -1px -1px 0 rgb(246, 245, 241),
        1px -1px 0 rgb(246, 245, 241),
        -1px 1px 0 rgb(246, 245, 241);
}
.town-text {
    color: #404041;
    font-size: 1.2em;
    font-weight: bold;
}
.city-text {
    color: #404041;
    font-size: 1.4em;
    font-weight: bold;
    text-shadow:
        1px 1px 0 rgb(246, 245, 241),
        -2px -1px 0 rgb(246, 245, 241),
        1px -1px 0 rgb(246, 245, 241),
        -1px 1px 0 rgb(246, 245, 241);
}
.quarter-text {
    color: #404041;
    font-style: italic;
    font-size: .8em;
}
.road-secondary-text {
    color: #000000;
    font-style: italic;
    font-size: .8em;
}

.village-text {
    color: #000000;
    font-size: .8em;
}

.island-text {
    color: #5a5a5b;
    font-style: italic;
    font-size: .9em;
    text-shadow:
        1px 1px 0 rgb(246, 245, 241),
        -1px -1px 0 rgb(246, 245, 241),
        1px -1px 0 rgb(246, 245, 241),
        -1px 1px 0 rgb(246, 245, 241);
}

</style>

<style scoped>
.color-white {
    color: #fff;
}
.opacity-slider-container {
    position: absolute;
    bottom: 1em;
    left: calc(50% - 5em);
    width: 10em;
    z-index: 2;
    padding: .1em .5em .1em .5em;
    border-radius: .5em;
}


:deep(.btn-sm) {
    border: none;
    border-radius: 0;
}

:deep(#right-click-menu li) {
    padding: 0;
}

:deep(.dropdown-menu) {
    padding: 0;
}

:deep(.dropdown-item) {
    padding: .25em .5em;
}

.vector-map-text {
    font-size: 1em;
    font-weight: bold;
    color: #000000;
}

</style>
